/**
 * Model reprezentujący miesięczny raport bilingowy dla konkretnego
 * oddziału / fizycznej placówki weterynaryjnej (VetClinic).
 */
export class MonthlyReportForClinic {


  /** Globalnie unikalny identyfikator raportu. */
  public uuid: string;

  /** Identyfikator klienta.
   * Pozwala powiązać ten sub-raport z głównym kontem rozliczeniowym.
   */
  public vClientId: number;

  /** Vetcode konkretnej, fizycznej placówki,
   * której dotyczą zebrane w tym obiekcie wyliczenia.
   */
  public vetcodeId: number;


  /** Rok, którego dotyczy rozliczenie. */
  public year: number;

  /** Miesiąc, którego dotyczy rozliczenie. */
  public month: number;

  /** Data i czas wygenerowania tego raportu w systemie. */
  public created: Date;
  public deleted: Date;


  /** Liczba aktywnych użytkowników w tej konkretnej placówce. */
  public activeUsers: number;

  /** Kwota opłaty naliczona na podstawie aktywnych użytkowników tego oddziału. */
  public activeUsersFee: number;

  /** Suma prowizji wygenerowanych wyłącznie w tej placówce. */
  public sumOfFee: number;

  /** Kwota zwrotów przypisanych do tego konkretnego oddziału. */
  public refundFromVetineo: number;

  /** Ostateczna wartość podsumowania dla tego gabinetu.
   */
  public summaryValue: number;


  /** Flaga/status określający, czy ten konkretny oddział wymaga wystawienia dokumentu. */
  public invoiceNeeded: number;

  /** Data wysłania faktury do tej placówki. */
  public invoiceSent: Date;

}
